import React from 'react';
import styles from './index.module.less';
import type { INavProductSubCategory } from '@/interface';
import classNames from 'classnames';

type TSubCateProductsProps = INavProductSubCategory;

const CompSubCateProducts: React.FC<TSubCateProductsProps> = (props) => {
    return (
        <li className={ styles['sub-category-container'] }>
            <p className={ styles['sub-category-title'] }>{props.title}</p>
            <ul className={ styles['sub-category-product-list'] }>
                {props.product.map((item) => {
                    return (
                        <li
                            key={ item.title }
                            className={ styles['sub-category-product'] }>
                            <a
                                href={ item.href }
                                className={ styles['sub-category-product-link'] }>
                                <div className={ styles['sub-category-product-img-container'] }>
                                    <img
                                        src={ item.image['pc'] }
                                        alt={ item.title }
                                        className={ styles['sub-category-product-img'] }
                                        loading={ 'lazy' }
                                    />
                                    {item.tag.map((item) => {
                                        return (
                                            <div
                                                key={ item.id }
                                                className={ classNames(
                                                    styles['sub-category-product-tag'],
                                                    styles[item.location],
                                                ) }
                                                dangerouslySetInnerHTML={{
                                                    __html: item.img,
                                                }}
                                            ></div>
                                        );
                                    })}
                                </div>

                                <p className={ styles['sub-category-product-title'] }>{item.title}</p>
                            </a>
                        </li>
                    );
                })}
            </ul>
        </li>
    );
};

export default CompSubCateProducts;
